let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("96g16")).then(() => parcelRequire('AOXtb'));